import React from "react";
import { inject, observer } from "mobx-react";
import { Button, Icon } from "oned";
import { ProgressBusiness, } from "@business/newCreateRequest/common/progress";
import { withRouter } from "react-router-dom";
import { ProblemBusiness } from "@business/newCreateRequest/stepsItems/problem";
import { combine } from "fe-toolkit";
import { AmplitudeEventName, StepType, ProblemLevel, PredefinedWoType, } from "@common/enums/base";
import { getCurrentEnv, isEmpty, sendAmplitude_Default } from "@common/utils";
import Cookies from "js-cookie";
var RecallCheck = ProblemLevel.RecallCheck, DuplicateCheck = ProblemLevel.DuplicateCheck;
var StepsHeader = inject(combine(ProgressBusiness, ProblemBusiness))(observer(function (props) {
    var back = props.back, step = props.step, history = props.history, level = props.level, setLevel = props.setLevel, currentUser = props.currentUser, lastLevel = props.lastLevel, woTypeId = props.woTypeId, serviceCodeWOType = props.serviceCodeWOType, duplicateWOList = props.duplicateWOList, recallWOList = props.recallWOList;
    var detailStepBackHandle = function () {
        switch (level) {
            case ProblemLevel.DifferentIssue:
                if (!isEmpty(recallWOList))
                    setLevel(RecallCheck);
                else if (!isEmpty(duplicateWOList))
                    setLevel(DuplicateCheck);
                else
                    setLevel(lastLevel);
                break;
            default:
                setLevel(level - 1);
        }
        back();
    };
    var problemStepBackHandle = function () {
        switch (level) {
            case ProblemLevel.LevelOne:
                history.push({ pathname: '/' });
                break;
            case ProblemLevel.DuplicateCheck:
                if (isResidentResponsibilityCount()) {
                    setLevel(ProblemLevel.ResidentResponsiBility);
                }
                else {
                    setLevel(lastLevel);
                }
                break;
            case ProblemLevel.ResidentResponsiBility:
                setLevel(lastLevel);
                break;
            case ProblemLevel.RecallCheck:
                if (!isEmpty(duplicateWOList)) {
                    setLevel(ProblemLevel.DuplicateCheck);
                    break;
                }
                if (isResidentResponsibilityCount()) {
                    setLevel(ProblemLevel.ResidentResponsiBility);
                    break;
                }
                setLevel(lastLevel);
                break;
            case ProblemLevel.HowToVideo:
                if (!isEmpty(recallWOList)) {
                    setLevel(ProblemLevel.RecallCheck);
                    break;
                }
                if (!isEmpty(duplicateWOList)) {
                    setLevel(ProblemLevel.DuplicateCheck);
                    break;
                }
                if (isResidentResponsibilityCount()) {
                    setLevel(ProblemLevel.ResidentResponsiBility);
                    break;
                }
                setLevel(lastLevel);
                break;
            default:
                setLevel(level - 1);
        }
    };
    var otherStepHandle = function () { return back(); };
    var handleBack = function () {
        backCount();
        if (step === StepType.Detail)
            detailStepBackHandle();
        else if (step === StepType.Problem)
            problemStepBackHandle();
        else
            otherStepHandle();
    };
    var isResidentResponsibilityCount = function () {
        return Cookies.get("residentResponsibilityCount") === 'true' &&
            (woTypeId ? woTypeId : serviceCodeWOType) === PredefinedWoType.ResidentResponsibility;
    };
    var backCount = function () {
        sendAmplitude_Default(AmplitudeEventName.NewRSP_Back, {
            userId: currentUser.userId,
            residentId: currentUser.residentId,
            currentStep: StepType[step],
            currentLevel: level,
            clientId: Cookies.get('clientId'),
            env: getCurrentEnv(),
        });
    };
    return (React.createElement("div", { className: "rsp-step-header py-3" },
        React.createElement("div", { className: "rsp-step-back" },
            React.createElement(Button, { type: "secondary", onClick: function () { return handleBack(); } },
                React.createElement(Icon, { type: "angle-left", className: "ds" })),
            React.createElement("a", { className: "text-primary px-3 hidden-sm", onClick: function () { return handleBack(); } }, "Back")),
        React.createElement("h1", { className: "rsp-step-title" }, "Request maintenance"),
        React.createElement("div", { className: "rsp-step-back" })));
}));
export default withRouter(StepsHeader);
